<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Remessas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="tooglePesquisa">
          <v-icon>search</v-icon>
        </v-btn>
        <v-btn
          depressed
          color="primary lighten-4"
          @click="$router.push('remessas/adicionar')"
          class="hidden-xs-only ml-2"
          >Adicionar</v-btn
        >
        <v-btn
          fab
          small
          color="primary lighten-4"
          @click="$router.push('remessas/adicionar')"
          class="hidden-sm-and-up ml-2"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-app-bar>

      <v-expand-transition>
        <v-row dense v-show="exibirPesquisa" class="pa-2">
          <v-col cols="12" pa-2>
            <v-text-field
              ref="pesquisa"
              label="Pesquisa"
              v-model="pesquisa"
              prepend-inner-icon="search"
              solo
              clearable
              single-line
              hide-details
              placeholder="Pesquisa"
              dark
              background-color="primary lighten-2"
              @click:clear="tooglePesquisa"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-data-table
        :search="pesquisa"
        :headers="headers"
        :items="remessas"
        hide-default-footer
        :loading="loading"
        no-data-text="Sem registros"
        no-results-text="Sem registros"
        loading-text="Carregando dados..."
      >
        <template v-slot:item.data="{ item }">
          <td>{{ item.data | dataBR }}</td>
        </template>
        <template v-slot:item.data_saida="{ item }">
          <td>{{ item.data_saida | dataBR }}</td>
        </template>
        <template v-slot:item.acoes="{ item }">
          <td>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  @click="$router.push('remessas/' + item.id + '/editar')"
                >
                  <v-list-item-title>
                    <v-icon>mdi-pencil</v-icon>Editar
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="abrirDialogoImpressao(item)">
                  <v-list-item-title>
                    <v-icon>mdi-printer</v-icon>Imprimir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <as-dialogo
      ref="dialogoCancelar"
      title="Cancelar Remessa"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Deseja confirmar o cancelamento dessa remessa?</v-label>
      <div slot="botoes">
        <v-btn depressed class="mr-2" @click="$refs.dialogoCancelar.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="cancelar"
          :disabled="loading"
          :loading="loading"
          >Confirmar</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImpressao"
      title="Imprimir Remessa"
      max-width="440px"
      hideCloseButton
    >
      <v-label>Deseja imprimir esta remessa?</v-label>
      <div class="d-flex pt-4" style="justify-content: flex-end">
        <v-btn
          depressed
          class="mr-2"
          @click="$refs.dialogoImpressao.fechar()"
          :disabled="imprimindo"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirRemessa"
          :disabled="imprimindo"
          :loading="imprimindo"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <iframe id="pdf-frame" v-show="false"></iframe>
  </v-container>
</template>

<script>
import ServiceRemessas from "@/services/remessas.js";
import { ptDateFormat } from "@/util/dateFormat.js";

import { createImpressaoRemessa } from "./impressao_remessa";

export default {
  name: "remessas",
  data() {
    return {
      user: {},
      ptDateFormat,
      loading: false,
      imprimindo: false,
      botaoAbrirDisabled: false,
      exibirPesquisa: false,
      pesquisa: "",
      pedido: {
        parcelas: null,
        prazo: null,
        promissorias: [],
      },
      remessas: [],
      remessa: {
        numero: "",
        motorista: "",
        placa: "",
        data_saida: "",
        hora_saida: "",
        data_chegada: "",
        hora_chegada: "",
      },
      pedidos_remessa: [],
      headers: [
        { text: "Número", value: "numero", width: "20%" },
        { text: "Data", value: "data", width: "20%" },
        { text: "Saída", value: "data_saida", width: "20%" },
        { text: "Motorista", value: "motorista", width: "35%" },
        { text: "Ações", value: "acoes", sortable: false, width: "5%" },
      ],
    };
  },
  mounted() {
    this.listar();
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let response = await ServiceRemessas.index();
        this.remessas = response.data.remessas;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirModalCancelarRemessa(remessa) {
      this.$refs.dialogoCancelar.abrir();
      this.remessa = this.clone(remessa);
    },
    async cancelar() {
      try {
        this.loading = true;
        await ServiceRemessas.cancelar(this.remessa.numero);
        this.listar();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoImpressao(remessa_selecionada) {
      this.remessa = this.clone(remessa_selecionada);
      this.$refs.dialogoImpressao.abrir();
    },
    async imprimirRemessa() {
      try {
        this.imprimindo = true;
        let remessa_response = await ServiceRemessas.carregarDadosImpressao(
          this.remessa.id
        );

        let impressao = createImpressaoRemessa(
          remessa_response.data.remessa,
          remessa_response.data.pedidos_estado,
          this.user
        );
        impressao.processar();
        impressao.imprimirPDF();

        /*   const pdfDocGenerator = pdfMake.createPdf(dd);
        pdfDocGenerator.getBlob((blob) => {
          var objectURL = URL.createObjectURL(blob);
          document.querySelector('#pdf-frame').src = '';
          document.querySelector('#pdf-frame').src = objectURL;
          objectURL = URL.revokeObjectURL(blob);
          window.setTimeout(function() {
            document.querySelector('#pdf-frame').contentWindow.print();
          }, 1000)
        }); */
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir remessa");
      } finally {
        this.$refs.dialogoImpressao.fechar();
        this.imprimindo = false;
      }
    },
  },
};
</script>
